// Fires an AddToCart event across common analytics pixels
// (Meta Pixel, UTMify, Google Tag Manager dataLayer)
export function trackAddToCart() {
  if (typeof window === 'undefined') return

  const w = window as any

  try {
    // Generar eventID ÚNICO
    const eventID = 'addtocart_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
    
    // Enviar a Meta Pixel
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'AddToCart', {
        content_name: 'Biblioteca de Patrones de Cuero',
        content_category: 'Marroquinería',
        currency: 'ARS',
        value: 19990,
      }, {
        eventID: eventID
      })
    }

    // GUARDAR en localStorage para usarlo en Shopify
    localStorage.setItem('fb_event_id', eventID)

    // Google Tag Manager / GA4 dataLayer
    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'ARS',
          value: 19990,
          items: [
            {
              item_name: 'Biblioteca de Patrones de Cuero',
              item_category: 'Marroquinería',
              price: 19990,
              quantity: 1,
            },
          ],
        },
      })
    } else {
      w.dataLayer = [
        {
          event: 'add_to_cart',
          ecommerce: {
            currency: 'ARS',
            value: 19990,
            items: [
              {
                item_name: 'Biblioteca de Patrones de Cuero',
                price: 19990,
                quantity: 1,
              },
            ],
          },
        },
      ]
    }

    // UTMify custom event hook (if utmify exposes one)
    if (typeof w.utmify === 'function') {
      w.utmify('track', 'AddToCart')
    }
  } catch (err) {
    // Silently fail — tracking should never break UX
    console.warn('AddToCart tracking failed:', err)
  }
}